/**
 * 歌詞取り込みシートの開閉状態
 *
 * 曲メニューや歌詞タブから開くため、シート本体は MiniPlayer 側で1つだけ
 * マウントし、開閉と保存完了の通知だけをこのストアで共有する。
 */

import { create } from 'zustand'

type LyricsImportTarget = {
  episodeId: number
  title: string
}

type LyricsImportState = {
  /** 取り込み対象の曲。null の間はシートを開かない */
  target: LyricsImportTarget | null
  /** 保存が完了するたびに増える。歌詞表示側の再取得トリガー */
  savedRevision: number
  openLyricsImport: (target: LyricsImportTarget) => void
  closeLyricsImport: () => void
  notifyLyricsSaved: () => void
}

export const useLyricsImport = create<LyricsImportState>((set) => ({
  target: null,
  savedRevision: 0,
  openLyricsImport: (target) => set({ target }),
  closeLyricsImport: () => set({ target: null }),
  notifyLyricsSaved: () => set((s) => ({ savedRevision: s.savedRevision + 1 })),
}))
